import Flex from 'components/Flex'
import React, { useEffect, useRef, useState } from 'react'

import { Col, Row } from 'antd'
import Button from 'components/Button/index'
import CalenderStyled from 'components/CalenderStyle/CalenderStyled'
import LeftArrowIcon from 'components/icons/LeftArrowIconcircle'
import RightArrowIconcircle from 'components/icons/RightArrowIconcircle'
import InfoCards from 'modules/InterviewerDashboard/Partials/DashboardCards'
import EmptyCard from 'modules/InterviewerDashboard/Partials/DashboardCards/EmptyCard'
import InfoCardPast from 'modules/InterviewerDashboard/Partials/DashboardCards/PastCard'
import InstitutesDetails from 'modules/InterviewerDashboard/Partials/InstitutesDetails'
import {
  CardRow,
  CardRow1,
  CarouselWrapper,
  HeaderFlex,
  LeftArrow,
  RightArrow,
  ScrollContainer,
  TextTitle,
  UserName,
  Wrapper,
} from 'modules/InterviewerDashboard/Partials/style'
import {
  getListOfDatesInterviewer,
  getListOfRolesForInterviwer,
} from 'modules/InterviewerDashboard/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import CalendarPaper from '../../components/CalenderStyle/CalenderPaper'

const InterviewerDashboard = () => {
  const params = useParams()
  const dispatch = new useDispatch()
  const UserData = useSelector(state => state?.auth?.userData)
  const [rolesList, setRolesList] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [sortBy, setSortBy] = useState('')
  const [search, setSearch] = useState('')
  const [cardData, setCardData] = useState([])
  const [calenderData, setCalenderData] = useState([])
  const [evaluations, setEvaluations] = useState('UPCOMING')
  const carouselRef = useRef(null)
  const [scrollable, setScrollable] = useState(false)

  const [activeCard, setActiveCard] = useState(null)
  const [roleFilter, setRoleFilter] = useState([])
  const [roundFilter, setRoundFilter] = useState([])
  const [filterData, setFilterData] = useState({
    roleId: '',
    round: '',
  })
  const [fromDate, setFromDate] = useState(null)
  const UserId = params?.userId ? params?.userId : UserData?._id

  useEffect(() => {
    ;(async () => {
      let response = await dispatch(
        getListOfDatesInterviewer(UserId, null, evaluations)
      )
      setCardData(response?.panelDetails)
    })()
    return () => {}
  }, [evaluations, UserId])
  useEffect(() => {
    ;(async () => {
      let response = await dispatch(getListOfDatesInterviewer(UserId))
      setCalenderData(response?.panelDetails)
    })()
    return () => {}
  }, [UserId])
  useEffect(() => {
    setFromDate(null)
    setActiveCard(null)
  }, [evaluations])

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      let params = {
        userId: UserId,
        roleId: null,
        startDate: fromDate,
        endDate: fromDate,
        page: page,
        sortBy: sortBy,
        search: search,
        evaluations: evaluations,
        filterData: filterData,
      }
      let response = await dispatch(getListOfRolesForInterviwer(params))
      setRolesList(response)
      setLoading(false)
    })()
    return () => {}
  }, [page, sortBy, search, evaluations, filterData, UserId, fromDate])

  useEffect(() => {
    const container = carouselRef.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }, [])

  const handleScroll = () => {
    const container = carouselRef?.current
    setScrollable(container?.scrollWidth > container?.clientWidth)
  }

  const scrollToLeft = () => {
    const container = carouselRef.current
    container.scrollLeft -= container.clientWidth
  }

  const scrollToRight = () => {
    const container = carouselRef.current
    container.scrollLeft += container.clientWidth
  }

  const onDateSelected = date => {}

  const headerRender = ({ value, onChange }) => {
    return <CalendarPaper value={value} onChange={onChange} />
  }

  return (
    <Wrapper>
      <Flex alignCenter spaceBetween>
        <HeaderFlex>
          <UserName>Interview & Drives</UserName>
          <Button.Primary text="View Overall" height={'32px'} />
        </HeaderFlex>
      </Flex>
      <Row>
        <Col span={18}>
          {cardData?.length > 0 ? (
            <ScrollContainer>
              <CarouselWrapper ref={carouselRef} onScroll={handleScroll}>
                <LeftArrow show={scrollable} onClick={scrollToLeft}>
                  <LeftArrowIcon />
                </LeftArrow>
                <CardRow>
                  {cardData?.map((Item, index) => (
                    <InfoCards
                      width={'200px'}
                      height="115px"
                      activeCard={activeCard}
                      setActiveCard={setActiveCard}
                      Item={Item}
                      id={index}
                      date={Item?.date}
                      count={Item?.studentsCount}
                      isDate={true}
                      setFromDate={setFromDate}
                      fromDate={fromDate}
                      key={index + Item?.date}
                    />
                  ))}
                </CardRow>
                <RightArrow show={scrollable} onClick={scrollToRight}>
                  <RightArrowIconcircle />
                </RightArrow>
              </CarouselWrapper>
            </ScrollContainer>
          ) : (
            <div style={{ padding: '20px' }}>
              <EmptyCard width={'200px'} height="115px" />
            </div>
          )}

          <TextTitle>Evaluations</TextTitle>
          <CardRow1>
            <InfoCardPast
              width={'230px'}
              height="auto"
              value="UPCOMING"
              active={evaluations === 'UPCOMING'}
              setEvaluations={setEvaluations}
              evaluations={evaluations}
              count={rolesList?.upcommingCount}
              setPage={setPage}
            />
            <InfoCardPast
              width={'230px'}
              height="auto"
              value="PAST"
              active={evaluations != 'UPCOMING'}
              setEvaluations={setEvaluations}
              evaluations={evaluations}
              count={rolesList?.pastCount}
              setPage={setPage}
            />
          </CardRow1>
        </Col>
        <Col span={6}>
          <CalenderStyled
            allDate={calenderData}
            setSelected={onDateSelected}
            setFromDate={setFromDate}
            fromDate={fromDate}
            isOccurance={true}
            headerRender={headerRender}
          />
        </Col>
      </Row>

      <InstitutesDetails
        rolesList={rolesList}
        loading={loading}
        page={page}
        setPage={setPage}
        setSortBy={setSortBy}
        setSearch={setSearch}
        search={search}
        roleFilter={roleFilter}
        setRoleFilter={setRoleFilter}
        setRoundFilter={setRoundFilter}
        roundFilter={roundFilter}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </Wrapper>
  )
}

export default InterviewerDashboard
